///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.duplicate_vendor = abcsetup.duplicate_vendor || {};
abcsetup.duplicate_vendor.workflow_signed = abcsetup.duplicate_vendor.workflow_signed || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.duplicate_vendor.workflow_signed = {
    // Variables
    workflow_task: null,
    disable_tab: true,

    /**
     *
     */
    init: function () {

        abcsetup.setTitle('Duplicate SAP Supplier');

        // Assign the local workflow_task var
        this.workflow_task = JSON.parse($('#WorkflowTask').val());
    },

    /**
     * _jquery.fieldLib
     *      Fields have been init - this is the callback
     */
    fieldsInit: function () {
        // abcsetup.duplicate_vendor.common.bindFormElems();

        // Bind any form element behavior
        this._bindFormElems();
    },

    /**
     * Bind any form element behavior
     */
    _bindFormElems: function () {
        const formSelector = 'form:has(input[type="hidden"][name="external_input"])';
        const $externalForm = $(formSelector);
    
        if ($externalForm.length > 0) {
            $externalForm.on('submit', function(event) {
                event.preventDefault();
                const form = this;
                const formData = new FormData(form);
                const generateUrlApi = '/api/duplicate_vendor/generate_signed_external_submit_url';
                const workflowTaskId = $(form).find('input[name="external_input"]').val();
    
                axios.post(generateUrlApi, {
                    workflow_task_id: workflowTaskId
                })
                .then(urlResponse => {
                    if (urlResponse.data && urlResponse.data.success && urlResponse.data.signed_url) {
                        const signedPostUrl = urlResponse.data.signed_url;
                        axios.post(signedPostUrl, formData)
                            .then(submitResponse => {
                                console.log('External submission successful:', submitResponse);
                                abcsetup.alerts.show(
                                    'Task Complete',
                                    'The form has been successfully submitted.',
                                    function () {
                                        window.location.href = '/';
                                    }
                                ); 
                            })
                            .catch(submitError => {
                                console.error('External submission POST error:', submitError.response || submitError);
                            });
                    } else {
                        throw new Error(urlResponse.data?.message || 'Failed to get signed submission URL.');
                    }
                })
                .catch(urlError => {
                     console.error('Error getting signed POST URL:', urlError.response || urlError);
                });
            });
        } else {
            console.log('Form not found');
        }
    },

    fieldError: function() {
        var errorField = $('form').find('.invalid').first();
        console.log(errorField.parent().html());
        abcsetup.unblockUI();
    }

}
